import _ from 'lodash';

export const getChangeContactLabelsConfig = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.editPolicyInfoLabels`,
    {},
  );
};

export const getChangeContactPolicyCards = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.policyCards`,
    [],
  );
};

export const getChangeContactPolicyCardsLength = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.policyCards`,
    [],
  ).length;
};

export const getChangeContactLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.isLoading`,
    false,
  );
};

export const getSelectedPolicy = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.selectedPolicy`,
    {},
  );
};

export const getGoGreenPolicyList = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.goGreenPolicyList`,
    [],
  );
};

export const getContactsPermissionsApi = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.contactsPermissionsApi`,
    '',
  );
};

export const getPoliciesApi = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.policiesApi`,
    '',
  );
};

export const getOtpApi = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.otpApi`,
    '',
  );
};

export const getVerifyOtpApi = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.verifyOtpApi`,
    '',
  );
};

export const getCustomerContactsApi = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.customerContactsApi`,
    '',
  );
};

export const getChangeContactErrorCode = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.errorCode`,
    '',
  );
};

export const getVerifyLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeContact.isVerifyLoading`,
    false,
  );
};
